var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgSoundOff = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 10,
    viewBox: "0 0 12 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.04399 0.66774L2.95601 2.73226H0.56305C0.234604 2.73226 0 2.99032 0 3.29531V6.67361C0 7.00205 0.234604 7.23666 0.56305 7.23666H2.95601L5.04399 9.32463C5.39589 9.67654 6.00587 9.44193 6.00587 8.92581V1.06657C6.00587 0.550438 5.39589 0.315834 5.04399 0.66774ZM10.8152 4.98446L11.8944 3.92874C12.0352 3.78798 12.0352 3.52991 11.8944 3.38915L11.3548 2.84956C11.2141 2.7088 10.956 2.7088 10.8152 2.84956L9.75953 3.92874L8.68035 2.84956C8.53959 2.7088 8.28152 2.7088 8.14076 2.84956L7.60117 3.38915C7.46041 3.52991 7.46041 3.78798 7.60117 3.92874L8.68035 4.98446L7.60117 6.06363C7.46041 6.2044 7.46041 6.46246 7.60117 6.60322L8.14076 7.14281C8.28152 7.28358 8.53959 7.28358 8.68035 7.14281L9.75953 6.06363L10.8152 7.14281C10.956 7.28358 11.2141 7.28358 11.3548 7.14281L11.8944 6.60322C12.0352 6.46246 12.0352 6.2044 11.8944 6.06363L10.8152 4.98446Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSoundOff);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/soundOff.6f74772411a5f526a5dcc108ee84fb82.svg";